export default __webpack_public_path__ + "images/546bd6468a4c673b17051ebe8be80123-pride_tablet.webp";